(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class ApexNavbar {
    constructor(el) {
      this.element = el;
      this.searchInput = el.querySelector('#navbar-search-input');
      this.desktopMenu = el.querySelector('.desktop-menu');
      this.desktopMenuItems = el.querySelectorAll('.desktop-menu > li');
      this.handleResize();
      window.addEventListener('resize', this.handleResize.bind(this));
    }

    handleResize() {
      if (window.innerWidth >= 1024) {
        const paddingAmount = window.innerWidth - this.desktopMenu.offsetWidth;
        this.desktopMenuItems.forEach((item) => item.classList.remove('!hidden', 'grow'));
        this.desktopMenu.offsetWidth; //reflow
        let itemsWidth = this.desktopMenuItems[this.desktopMenuItems.length - 1].offsetWidth + paddingAmount;
        //iterate through items in reverse order
        for (let i = 0; i < this.desktopMenuItems.length; i++) {
          if (i === this.desktopMenuItems.length - 1) {
            continue;
          }
          const item = this.desktopMenuItems[i];
          itemsWidth += item.offsetWidth;
          if (itemsWidth > window.innerWidth) {
            item.classList.add('!hidden');
          }
        }
        this.desktopMenuItems.forEach((item) => item.classList.add('grow'));
      }

      if (this.searchInput) {
        if (window.innerWidth < 780) {
          this.searchInput.placeholder = 'Search…';
        } else {
          this.searchInput.placeholder = 'Search for a product, brand, or SKU…';
        }
      }
    }
  }

  const navbar = document.getElementById('site-navbar');
  if (navbar) {
    new ApexNavbar(navbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header2"]) return;
  try {
    
  class ApexNavbar {
    constructor(el) {
      this.element = el;
      this.searchInput = el.querySelector('#navbar-search-input');
      this.desktopMenu = el.querySelector('.desktop-menu');
      this.desktopMenuItems = el.querySelectorAll('.desktop-menu > li');
      this.handleResize();
      window.addEventListener('resize', this.handleResize.bind(this));
    }

    handleResize() {
      if (window.innerWidth >= 1024) {
        const paddingAmount = window.innerWidth - this.desktopMenu.offsetWidth;
        this.desktopMenuItems.forEach((item) => item.classList.remove('!hidden', 'grow'));
        this.desktopMenu.offsetWidth; //reflow
        let itemsWidth = this.desktopMenuItems[this.desktopMenuItems.length - 1].offsetWidth + paddingAmount;
        //iterate through items in reverse order
        for (let i = 0; i < this.desktopMenuItems.length; i++) {
          if (i === this.desktopMenuItems.length - 1) {
            continue;
          }
          const item = this.desktopMenuItems[i];
          itemsWidth += item.offsetWidth;
          if (itemsWidth > window.innerWidth) {
            item.classList.add('!hidden');
          }
        }
        this.desktopMenuItems.forEach((item) => item.classList.add('grow'));
      }

      if (this.searchInput) {
        if (window.innerWidth < 780) {
          this.searchInput.placeholder = 'Search…';
        } else {
          this.searchInput.placeholder = 'Search for a product, brand, or SKU…';
        }
      }
    }
  }

  const navbar = document.getElementById('site-navbar');
  if (navbar) {
    new ApexNavbar(navbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          // swiper element
          const swiperEl = document.querySelector('.recommended-products-swiper');

          // swiper parameters
          const swiperParams = {
            slidesPerView: 'auto',
            spaceBetween: 16,
            grabCursor: true,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            scrollbar: {
              draggable: true,
            },
            breakpoints: {
              640: {
                slidesOffsetBefore: 24,
                slidesOffsetAfter: 24,
              },
              1024: {
                spaceBetween: 24,
              },
            },
            on: {
              init() {
                swiperEl.classList.add('swiper-init');
                swiperEl.classList.remove('space-x-4', 'ps-4');
              },
            },
          };

          // now we need to assign all parameters to Swiper element
          Object.assign(swiperEl, swiperParams);

          // and now initialize it
          swiperEl.initialize();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const recentlyViewedProductsSection = document.querySelector('.recently-viewed-products');
    const currentProductHandle = recentlyViewedProductsSection.dataset.currentProduct;

    function getRecentlyViewedProducts() {
      let recentlyViewed = [];
      try {
        recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
      } catch (e) {
        console.error('Error parsing recently viewed products:', e);
        localStorage.removeItem('recentlyViewed');
      }
      return recentlyViewed;
    }

    function setRecentlyViewedProduct(handle) {
      let recentlyViewed = getRecentlyViewedProducts();
      recentlyViewed = recentlyViewed.filter((product) => product.handle !== handle);
      recentlyViewed.unshift({ handle });
      if (recentlyViewed.length > 10) {
        recentlyViewed.pop();
      }
      localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
    }

    function fetchProductData(handle) {
      if (!handle || handle == '\{\{ product.handle \}\}') {
        return Promise.resolve();
      }
      const url = `${window.Shopify.routes.root}products/${handle}?view=card`;
      return fetch(url)
        .then((response) => response.text())
        .then((html) => {
          return { handle, html };
        })
        .catch((error) => console.error('Error fetching product data:', error));
    }

    function renderRecentlyViewedProducts() {
      const recentlyViewed = getRecentlyViewedProducts();
      if (recentlyViewed.length > 0) {
        const swiperContainer = document.querySelector('.recently-viewed-products-swiper');
        swiperContainer.innerHTML = '';

        Promise.all(recentlyViewed.map((product) => fetchProductData(product.handle)))
          .then((products) => {
            products = products.filter((product) => product && product.html && product.handle !== currentProductHandle);

            if (products.length === 0) {
              return;
            } else {
              recentlyViewedProductsSection.classList.remove('hidden');
            }
            products.forEach((product) => {
              const productHtml = `
                <swiper-slide class="shrink-0 recently-viewed-product-item block pb-5">
                  ${product.html}
                </swiper-slide>
              `;
              swiperContainer.insertAdjacentHTML('beforeend', productHtml);
            });

            // Initialize the swiper
            const swiperEl = document.querySelector('.recently-viewed-products-swiper');
            const swiperParams = {
              slidesPerView: 'auto',
              spaceBetween: 16,
              grabCursor: true,
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              scrollbar: {
                draggable: true,
              },
              breakpoints: {
                640: {
                  slidesOffsetBefore: 24,
                  slidesOffsetAfter: 24,
                },
                1024: {
                  spaceBetween: 24,
                },
              },
              on: {
                init() {
                  swiperEl.classList.add('swiper-init');
                  swiperEl.classList.remove('space-x-4', 'ps-4');
                },
              },
            };
            Object.assign(swiperEl, swiperParams);
            swiperEl.initialize();
          })
          .catch((error) => console.error('Error rendering recently viewed products:', error));
      }
    }

    renderRecentlyViewedProducts();
  });

  } catch(e) { console.error(e); }
})();
})();
